


import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from "react-datepicker";

import { useDispatch, useSelector } from "react-redux";
import { AddInvoiceApi } from "../../../service/bankApi/addInvoice";
import { toast, ToastContainer } from "react-toastify";
import { getInvoicesType } from "../../../service/bankApi/getInvoiceTypes";
import Select from "react-select";
import VerificationTable from "../../components/Dashboard/verificationScreen/verificationTable";
import { getPropertyListApi } from "../../../service/property/propertyList"
import UploadInvoicesTable from "../uploadedInvoices/uploadedInvoicesTable";
import PropertyListTable from "./propertyListTable";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import NewPropertyListTable from "./newPropertyListTable";
import { cancelInvoiceApi } from "../../../service/bankApi/cancelInvoice";
import { approveInvoiceApi } from "../../../service/bankApi/approveInvoice";
import { approvePropApi } from "../../../service/property/approveProperty";
import { cancelPropApi } from "../../../service/property/cancelProperty";
import PendingPropertyListTable from "./pendingPropertyListTable";
import ApprovedPropertyListTable from "./approvedPropListTable";
import CancelledPropertyListTable from "./cancelledPropListTable";
import OtpModal from "../../components/OtpModal/OtpModal";
import {auditPropertyApi} from "../../../service/property/auditProperty";
import { formatDate } from "../../../function/commonFunction";
import { setPropertyActiveApi } from "../../../service/property/setpropertyActive";
import dayjs from "dayjs";
import { setLoading } from "../../../feature/authSlice";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Paper,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { findSubMenuByName } from "./MenuUtlis";
import { redirectToDash } from "../redirectToDash";

const PropertyListPage = () => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const[openTab,setOpenTab] = useState(1)
  const [auditDisplay, setAuditDisplay] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [actionPerformArray, setActionPerformArray] = useState([]);
  const { permissionArr } = useSelector((state) => state.auth);
  const [filterType, setFilterType] = useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
  const notifyTopRight = () => {
    toast.success("✔️ Submit Successfully !!!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  
  const notifyTopDynamic = (action,message) => {
   if(action=="e"){
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
   }else if (action =="s"){
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
   }
  };
  const notifyTopRightDynamic = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,

      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,

      });
    }
  };

  const[propertiesList,setPropertiesList] = useState([])
  const[newPropertyList,setNewPropertyList] = useState([])
  const [approvedPropertyList,setApprovedPropertyList] = useState([])
  const[cancelledPropertyList,setCancelledPropertyList] = useState([])
  const [userArr,setUserArr] = React.useState([])
  const [permissionModal, setPermissionModal] = useState(false);
  const [permissionModalActive, setPermissionModalActive] = useState(false);
  const [modaleType, setModalType] = useState(null);
  const [reason,setReason] = useState("")
  const [cancelPropId, setCancelPropId] = useState("");
  const [approvePropId, setApprovePropId] = useState(null);
  const [approveFileId, setApproveFileId] = useState(null);
  const [cancelFileId, setCancelFileId] = useState(null);
  const [approveArrayData,setApproveArrayData] = useState([])
  const [approvePropertyModal,setApprovePropertyModal] =useState(false)
  const [ isLoading,setIsLoading] = useState(false)
  const [approveAction,setApproveAction] = useState("")
  const [approveOtp,setApproveOtp] = useState("")
  const [otpModalStatus,setOtpModalStatus] = useState(false)
  const [otpValue, setOtpValue] = useState("")


  // Pending Pagination states

  const [pagePending , setPagePending] = useState(1);
  const [pageSizePending, setPageSizePending] = useState(10);
  const [totalPagePending, setTotalPagePending] = useState(1);
  const [searchValuePending, setSearchValuePending] = useState("");
  const [totalPendingCount, setTotalPendingCount] = useState(0);

  // New Pagination states

  const [pageNew, setPageNew] = useState(1);
  const [pageSizeNew, setPageSizeNew] = useState(10);
  const [totalPageNew, setTotalPageNew] = useState(1);
  const [searchValueNew, setSearchValueNew] = useState("");
  const [totalNewCount, setTotalNewCount] = useState(0);

  // Approved Pagination states

  const [pageApproved, setPageApproved] = useState(1);
  const [pageSizeApproved, setPageSizeApproved] = useState(10);
  const [totalPageApproved, setTotalPageApproved] = useState(1);
  const [searchValueApproved, setSearchValueApproved] = useState("");
  const [totalApprovedCount, setTotalApprovedCount] = useState(0);
  

    //  Cancelled Pagination states

    const [pageCancelled, setPageCancelled] = useState(1);
    const [pageSizeCancelled, setPageSizeCancelled] = useState(10);
    const [totalPageCancelled, setTotalPageCancelled] = useState(1);
    const [searchValueCancelled, setSearchValueCancelled] = useState("");
    const [totalCancelledCount, setTotalCancelledCount] = useState(0);

    const [toDate, setToDate] = React.useState(dayjs(new Date));
    const [fromDate, setFromDate] = React.useState(dayjs(new Date));
    const { permissions } = useSelector(state => state.permissionsData)

  const pendingColumns = [
    {
      Header: "",
      Footer: "",
      accessor: "aaa",
    },
    {
      Header: "Location Name",
      Footer: "Location Name",
      accessor: "LocationName",
    },
    // {
    //   Header: "Location Code",
    //   Footer: "Location Code",
    //   accessor: "LocationCode",
    // },
   
    {
      Header: "Full Address",
      Footer: "Full Address",
      accessor: "FullAddress",
    },
    {
      Header: "Area Sqft",
      Footer: "Area Sqft",
      accessor: "CarpetArea",
    },
    {
      Header: "Pincode",
      Footer: "Pincode",
      accessor: "Pincode",
    },
    { Header: "Branch Code",
    Footer: "Branch Code",
    accessor: "BranchCode",
    },
    { Header: "GSTIN",
    Footer: "GSTIN",
    accessor: "GSTIN",
    },
    { Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "LeaseEndDate",
    },
    // {
    //   Header: "View Vendor",
    //   Footer: "View Vendor",
    //   accessor: "Actionsss",
    // },
    {
      Header: "Actions",
      Footer: "Actions",
      accessor: "Actionss",
    },
  ];
  const columns = [
    {
      Header: "Location Name",
      Footer: "Location Name",
      accessor: "LocationName",
    },
    // {
    //   Header: "Location Code",
    //   Footer: "Location Code",
    //   accessor: "LocationCode",
    // },
   
    {
      Header: "Full Address",
      Footer: "Full Address",
      accessor: "FullAddress",
    },
    {
      Header: "Area Sqft",
      Footer: "Area Sqft",
      accessor: "CarpetArea",
    },
    {
      Header: "Pincode",
      Footer: "Pincode",
      accessor: "Pincode",
    },
    { Header: "Branch Code",
    Footer: "Branch Code",
    accessor: "BranchCode",

    },
    { Header: "GSTIN",
    Footer: "GSTIN",
    accessor: "GSTIN",

    },
    { Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "LeaseEndDate",

    },
// {
//         Header: "View Vendor",
//         Footer: "View Vendor",
//         accessor: "Actionsss",
//       },
    {
      Header: "Actions",
      Footer: "Actions",
      accessor: "Actionss",
    },
   
   






  ];

  const cancelledColumns = [
    {
      Header: "Location Name",
      Footer: "Location Name",
      accessor: "LocationName",
    },
    // {
    //   Header: "Location Code",
    //   Footer: "Location Code",
    //   accessor: "LocationCode",
    // },
   
    {
      Header: "Full Address",
      Footer: "Full Address",
      accessor: "FullAddress",
    },
    {
      Header: "Area Sqft",
      Footer: "Area Sqft",
      accessor: "CarpetArea",
    },
    {
      Header: "Pincode",
      Footer: "Pincode",
      accessor: "Pincode",
    },
    { Header: "Branch Code",
    Footer: "Branch Code",
    accessor: "BranchCode",

    },
    { Header: "GSTIN",
    Footer: "GSTIN",
    accessor: "GSTIN",

    },
    { Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "LeaseEndDate",

    },
    
    {
      Header: " Rejection Reason",
      Footer: " Rejection Reason",
      accessor: "RejectionReason",
    },
    // {
    //   Header: "View Vendor",
    //   Footer: "View Vendor",
    //   accessor: "Actionsss",
    // },
    
    // {
    //   Header: "View Users",
    //   Footer: "View Users",
    //   accessor: "Actionss",
    // },
    {
      Header: "Action",
      Footer: "Action",
      accessor: "Actionssss",
    },
   
   
   






  ];
  const newColumns = [
    {
      Header: "",
      Footer: "",
      accessor: "aaa",
    },
    {
      Header: "Location Name",
      Footer: "Location Name",
      accessor: "LocationName",
    },
    // {
    //   Header: "Location Code",
    //   Footer: "Location Code",
    //   accessor: "LocationCode",
    // },
   
    {
      Header: "Full Address",
      Footer: "Full Address",
      accessor: "FullAddress",
    },
    {
      Header: "Area Sqft",
      Footer: "Area Sqft",
      accessor: "CarpetArea",
    },
    {
      Header: "Pincode",
      Footer: "Pincode",
      accessor: "Pincode",
    },
    { Header: "Branch Code",
    Footer: "Branch Code",
    accessor: "BranchCode",

    },
    { Header: "GSTIN",
    Footer: "GSTIN",
    accessor: "GSTIN",

    },
    { Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "LeaseEndDate",

    },
    // {
    //   Header: "View Vendor",
    //   Footer: "View Vendor",
    //   accessor: "Actionsss",
    // },
    
    // {
    //   Header: "View Users",
    //   Footer: "View Users",
    //   accessor: "ViewUsers",
    // },

    {
      Header: "Action",
      Footer: "Action",
      accessor: "Actionssss",
    },
   






  ];

  // Helper function to find a specific action in a submenu
  const hasAction = (submenu, actionName) => submenu.Actions.includes(actionName);
  // Find the "List Property" submenu under "Properties"
  const propertiesMenu = findSubMenuByName(permissions, 'Properties');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu.SubMenus, 'List Property') : null;
  const newSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu.SubMenus, 'New') : null;

  const canViewUsers=newSubMenu?hasAction(newSubMenu,'ViewUsers'):false;
  const canViewVendors=newSubMenu?hasAction(newSubMenu,'ViewVendors'):false;

  const approvedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu.SubMenus, 'Approved') : null;
  const rejectedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu.SubMenus, 'Rejected') : null;
  const canApprovedViewUsers=approvedSubMenu?hasAction(approvedSubMenu,'ViewUsers'):false;
  const canApprovedViewVendors=approvedSubMenu?hasAction(approvedSubMenu,'ViewVendors'):false;
  const canRejectedViewUsers=rejectedSubMenu?hasAction(rejectedSubMenu,'ViewUsers'):false;
  const canRejectedViewVendors=rejectedSubMenu?hasAction(rejectedSubMenu,'ViewVendors'):false;
  
// Conditionally add the "View Vendor" column
if (canViewVendors) {
  newColumns.splice(8, 0, {
    Header: "View Vendor",
    Footer: "View Vendor",
    accessor: "ViewVendors",
  });
}
if (canViewUsers) {
  newColumns.splice(9, 0, {
      Header: "View Users",
      Footer: "View Users",
      accessor: "ViewUsers",
  });
}
// Conditionally add the "View Vendor" column
if (canApprovedViewVendors) {
  columns.splice(7, 0, {
    Header: "View Vendor",
    Footer: "View Vendor",
    accessor: "ViewVendors",
  });
}
// Conditionally add the "View Vendor" column
if (canRejectedViewVendors) {
  cancelledColumns.splice(8, 0, {
    Header: "View Vendor",
    Footer: "View Vendor",
    accessor: "ViewVendors",
  });
}
if (canRejectedViewUsers) {
  cancelledColumns.splice(9, 0, {
      Header: "View Users",
      Footer: "View Users",
      accessor: "ViewUsers",
  });
}
  useEffect(() => {

   onLoadData()
  
 
  }, [openTab,pageApproved,pagePending,pageNew,pageCancelled,pageSizeNew,pageSizePending,pageSizeApproved,pageSizeCancelled])

  const formatDate=(dateString)=>{
    const dateObject = new Date(dateString);
  
  // Get year, month, and day from the date object
  const year = dateObject.getFullYear();
  const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() is zero-indexed
  const day = ('0' + dateObject.getDate()).slice(-2);

  // Construct the formatted date string
  return `${year}-${month}-${day}`;
   }

   function onLoadData(val,val2) {
    let filterType2=filterType;
    switch (filterType?filterType:val2) {
      case "Telephone":
        filterType2="ServiceType@=Telephone"
        break;
      case "Maintenance/Electricity":
        filterType2="ServiceType!@=Telephone"
        break;
      default:
         filterType2="ServiceType@=Telephone"
        break;
    }
    // console.log(openTab)
    setPropertiesList([])
    setNewPropertyList([])
    setApprovedPropertyList([])
    setCancelledPropertyList([])
   
     if(openTab === 1){
      
      var data = {

        Filter: formatDate(fromDate)!==formatDate(toDate)?`status==2,LeaseEndDate>=${formatDate(fromDate)},LeaseEndDate<=${formatDate(toDate)}`+","+filterType2:'status==2'+","+filterType2,
        OrderBy: "",
        PageSize: pageSizeNew,
        PageNumber: pageNew,
        Keyword:searchValueNew
  
      }
      // console.log(data,"Values of page")
      dispatch(getPropertyListApi(data, (response) => { 
        
     
        setNewPropertyList(response.data.result.properties)
        setTotalNewCount(response.data.result.TotalCount);
        if (parseInt(response?.data?.result?.TotalCount) % response.data.result.PageSize === 0) {
          setTotalPageNew(parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize));
        } else {
          setTotalPageNew(
            parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize + 1)
          );
        }
        
         }, (err) => { 
          // console.log(err) 
          
        }))
    }
    else if(openTab === 2){
      var data = {

        Filter: formatDate(fromDate)!==formatDate(toDate)?`status==3,LeaseEndDate>=${formatDate(fromDate)},LeaseEndDate<=${formatDate(toDate)}`+","+filterType2:'status==3'+","+filterType2,
        OrderBy: "",
        PageSize: pageSizeApproved,
        PageNumber: pageApproved,
        Keyword:searchValueApproved
  
      }
      dispatch(getPropertyListApi(data, (response) => { 
        
     
        setApprovedPropertyList(response.data.result.properties)
        // console.log(response.data,"property count") 

        setTotalApprovedCount(response.data.result.TotalCount);
        if (parseInt(response?.data?.result?.TotalCount) % response.data.result.PageSize === 0) {
          setTotalPageApproved(parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize));
        } else {
          setTotalPageApproved(
            parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize + 1)
          );
        }
      }, (err) => { console.log(err) }))
    }
    else if(openTab === 3){
      
      var data = {

        Filter: formatDate(fromDate)!==formatDate(toDate)?`status==4,LeaseEndDate>=${formatDate(fromDate)},LeaseEndDate<=${formatDate(toDate)}`+","+filterType2:'status==4'+","+filterType2,
        OrderBy: "",
        PageSize: pageSizeCancelled,
        PageNumber: pageCancelled,
        Keyword:searchValueCancelled
  
      }
      dispatch(getPropertyListApi(data, (response) => { 
        
     
        setCancelledPropertyList(response.data.result.properties)
        setTotalCancelledCount(response.data.result.TotalCount);
        if (parseInt(response?.data?.result?.TotalCount) % response.data.result.PageSize === 0) {
          setTotalPageCancelled(parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize));
          
        } else {
          setTotalPageCancelled(
            parseInt(response?.data?.result?.TotalCount / response.data.result.PageSize + 1)
          );
          

        } }, (err) => {
           console.log(err)
           
          }))
    }
  }
  
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    
  if (typingTimeout) {
    clearTimeout(typingTimeout);
  }

  // Set a new timeout to call the API after the user stops typing
  const timeoutId = setTimeout(() => {
    onLoadData(); // Call your API with the current search value
  }, 1000); // Adjust the delay as needed (500ms in this case)

  // Save the timeout ID
  setTypingTimeout(timeoutId);

  // Clean up the timeout when the component unmounts or values change
  return () => clearTimeout(timeoutId);

  }, [searchValueApproved, searchValuePending, searchValueNew, searchValueCancelled]);


  function handleTabExpanded(val) {
// var data  ={
//   PropertyId:val.Id
// }
// dispatch(getUserByPropIdApi(data,(res)=>{
//   setUserArr(res.data?.result)
// },()=>{}))
  }

function handleActionPending (e,action,data){

  if (action == "cancel") {
    setModalType(0);
    setPermissionModal(true);
    setCancelPropId(data.Id);
    setCancelFileId(data.FileId);
  } else if (action == "approve") {
    setModalType(1);

    setPermissionModal(true);
    setApprovePropId(data.Id);
    setApproveFileId(data.FileId);
  }else if (action == "audit") {
    var data = {
      PropertyId:data.Id
    };
    
    dispatch(
      auditPropertyApi(
        data,
        (res) => {
          setActionPerformArray(res.data.result);
          // onLoadData();
          setAuditDisplay(true);
           
        },
        (err) => { 
          console.log(err);
          
        }
      )
    );
  }else if (action == "active"){
    setApprovePropId(data.Id);
    setPermissionModalActive(true)
  }


}

function handleApproveCalled() {
setIsLoading(true)


  var data =  [approvePropId]
 
  dispatch(
    approvePropApi(
      data,
      (res) => {
setIsLoading(false)

        setPermissionModal(false);
        onLoadData();
        toast.success("✔️ Approved successfully")
      },
      (err) => {
        setIsLoading(false)
        
      }
    )
  );
}
function handleCancelCalled() {
  setIsLoading(true)
  
  var data = {
    PropertyId: cancelPropId,
    // FileId: cancelFileId,
    RejectionReason:reason
  };
 if(reason!==''){
try {
  dispatch(
    cancelPropApi(
      data,
      (res) => {
        onLoadData();
        setIsLoading(false)
        setReason('')
        
        setPermissionModal(false);
        // console.log(res);
        notifyTopDynamic("s","Property rejected successfully")
      },
      (err) => {
        setIsLoading(false)
        
        console.log(err);
        setReason('')
      }
    )
  );
} catch (error) {
  
  setReason('')
}
 }else{
toast.error('Please provide a reason')
 }
 
}
  
function handleActionMultipleApprove (data){
  setApprovePropertyModal(true)
  // console.log(data)
setApproveArrayData(data)
}

function handleMultipleApproveCalled (){
  
  setIsLoading(true)

  var data ={
    ResendOtp: false,
    OTP: otpValue,
    PropertyIds: approveArrayData }


  dispatch(
    approvePropApi(
      data,
      (res) => {

        if (res.data.result.ResponseMessage === "OTP sent successfully") {
          setIsLoading(false)
          toast.success(res.data.result.ResponseMessage)
          
          setOtpModalStatus(true)
          setApprovePropertyModal(false);
        }
        else{
          // console.log(res.data,"Approve INvocie")
          setIsLoading(false)
          
          setApprovePropertyModal(false);
          setPropertiesList([])
          onLoadData();
          setOtpModalStatus(false)
          toast.success("✔️ Approved Successfully")
          // notifyTopRight();
          setOtpValue("")
            }
       
      },
      (err) => {
                setIsLoading(false)
        
      }
    )
  );
}

function handleApproveInvoiceOtp(element) {
  setOtpValue(element);
}

function handleResendOtp (){
  var data = {
    ResendOtp: true,
    OTP: "",
    PropertyIds: approveArrayData
  }
  
 try {
  dispatch(
    approvePropApi(
      data,
      (res) => {

        
toast.success(res.data.result.ResponseMessage)
      },
      (err) => { 
        
      }
    )
  );
 } catch (error) {
  
 }
}

const toggleRowExpansion = (index) => {
  setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
};
function parseStringToObjects(inputString) {
  // Removing escape characters from the input string
  inputString = inputString?.replace(/\\"/g, '"').replace(/\\'/g, "'");

  // Parsing the string into a JavaScript object
  let data = JSON.parse(inputString);
  // console.log(data, "comverted");
  return data;
}

//  Pending Pagination Function ----------------


const handleSearchPending = (e) => {
  // setPage(1)

  setSearchValuePending(e.target.value);
  if (searchValuePending.trim().length >= 2) {
    onChangePagePending(1);
  }
};

const handleChangeRowsPerPagePending = (e) => {
  // console.log(e)
  setSearchValuePending("");
  setPagePending(1);
  setPageSizePending(e.target.value);
};

const onChangePagePending = (e, p) => {
  // setPage(p);
  setPagePending(e);
};

//  new Pagination Function -----------------------------

 const handleSearchNew = (e) => {
  // setPage(1)

  setSearchValueNew(e.target.value);
  if (searchValueNew.trim().length >= 2) {
    onChangePageNew(1);
  }
};

const handleChangeRowsPerPageNew = (e) => {
  // console.log(e)
  setSearchValueNew("");
  setPageNew(1);
  setPageSizeNew(e.target.value);
};

const onChangePageNew = (e, p) => {
  // setPage(p);
  // console.log(e,"Page nr pchanges")
  setPageNew(e);
};

  // Approve Pagination Function ----------------------------------------
  const handleSearchApproved = (e) => {
    // setPage(1)

    setSearchValueApproved(e.target.value);
    if (searchValueApproved.trim().length >= 2) {
      onChangePageApproved(1);
    }
  };

  const handleChangeRowsPerPageApproved = (e) => {
    // console.log(e)
    setSearchValueApproved("");
    setPageApproved(1);
    setPageSizeApproved(e.target.value);
  };

  const onChangePageApproved = (e, p) => {
    // setPage(p);
    // console.log(e,"approved")
    setPageApproved(e);
  };

   // Cancelled Pagination Function ----------------------------------------
   const handleSearchCancelled = (e) => {
    // setPage(1)

    setSearchValueCancelled(e.target.value);
    if (searchValueCancelled.trim().length >= 2) {
      onChangePageCancelled(1);
    }
  };

  const handleChangeRowsPerPageCancelled= (e) => {
    // console.log(e)
    setSearchValueCancelled("");
    setPageCancelled(1);
    setPageSizeCancelled(e.target.value);
  };

  const onChangePageCancelled = (e, p) => {
    // setPage(p);
    setPageCancelled(e);
  };

  function handleSeeVendor (e,tab){
    // console.log(tab)
    localStorage.setItem("propId",e.Id)
navigate("/viewVendors", { state: { tab ,filterType} })
  }

  function handleActiveProperty (){
    var data ={
      PropertyId:approvePropId
    }

    dispatch((setPropertyActiveApi(data,(res)=>{
      setPermissionModalActive(false)
      notifyTopRightDynamic("Property Activated","s")
      
      onLoadData()
     },(err)=>{
      setPermissionModalActive(false)
      })))
  }

  function assignUsers (e){
    localStorage.setItem("propId",e.Id)
navigate("/assignUsers")
  }
  
  // const handleTab=(tab)=>{
  //   console.log(tab)
  //  if(tab===1){
  //   setOpenTab(1)
  //   setFromDate(dayjs(new Date))
  //   setToDate(dayjs(new Date))
  //  }else if(tab===2){
  //   setOpenTab(2)
  //   setFromDate(dayjs(new Date))
  //   setToDate(dayjs(new Date))
  //  }else if(3){
  //   setOpenTab(3)
  //   setFromDate(dayjs(new Date))
  //   setToDate(dayjs(new Date))
  //  }else if(4){
  //   setOpenTab(4)
  //   setFromDate(dayjs(new Date))
  //   setToDate(dayjs(new Date))
  //  }
  // }

// utils.js
 const formatAuditDate = (dateString) => {
  const date = new Date(dateString);
  
  // Custom options for formatting the date
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options).replace(/ /g, '-');

  // Options for formatting the time
  const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
  const formattedTime = date.toLocaleTimeString(undefined, timeOptions);

  return `${formattedDate} ${formattedTime}`;
};


  // Helper function to find the "List Property" submenu within "Properties"
  const findListPropertySubMenus = () => {
    const propertiesMenu = permissions?.find(menu => menu?.MenuItemName === 'Properties');
    if (!propertiesMenu) return [];

    const listPropertySubMenu = propertiesMenu?.SubMenus.find(subMenu => subMenu?.MenuItemName === 'List Property');
    if (!listPropertySubMenu) return [];

    return listPropertySubMenu?.SubMenus;
  };

  // Get the submenus of "List Property"
  const listPropertySubMenus = findListPropertySubMenus();

  // Handle tab changes with a switch statement
  const handleTab = (eventKey) => {
    switch (eventKey) {
      case 'New':
        setOpenTab(1)
        setFromDate(dayjs(new Date))
        setToDate(dayjs(new Date))
        setSearchValueApproved('')
        setSearchValueCancelled('')
        setSearchValuePending('')
        break;
      case 'Approved':
        setOpenTab(2)
        setFromDate(dayjs(new Date))
        setToDate(dayjs(new Date))
        setSearchValueNew('')
        setSearchValueCancelled('')
        setSearchValuePending('')
        break;
      case 'Rejected':
        setOpenTab(3)
    setFromDate(dayjs(new Date))
    setToDate(dayjs(new Date))
setSearchValueApproved('')
setSearchValuePending('')
setSearchValueNew('')
        break;
      default:
        // console.log('Default tab action');
        break;
    }
  };
  
  useEffect(() => {
    if(!listPropertyMenu){
      redirectToDash(navigate,toast)
    }
  
}, [])
  return (
    <>
      <ToastContainer />
      {/* {  toaster && <AutohideToaster action={actionMessage} message={message} handleFucntion={()=>{setToaster(false)}}/>} */}
      <div className="row d-flex justify-content-between">
        {/* <BalanceCardSlider /> */}
        <div className="row">
        <div className="col-xxl-12">
          <div className="card">
          

            <Tab.Container defaultActiveKey="New">
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="heading me-2">Property List</h4>
                <nav>
                  <Nav as="div" className="order nav nav-tabs" role="tablist">
                    {/* <Nav.Link
                      as="button"
                      eventKey="Pending"
                      onClick={()=>handleTab(1)}
                    >
                     Pending
                    </Nav.Link> */}
                             {listPropertySubMenus.map(subMenu => (
        <Nav.Link
          key={subMenu.MenuItemId}
          as="button"
          eventKey={subMenu.MenuItemName}
          onClick={() => handleTab(subMenu.MenuItemName)} // Replace handleTab with your logic
        >
          {subMenu.MenuItemName}
        </Nav.Link>
      ))}
                    {/* {permissions.includes("Property_New ")&&(
                                          <Nav.Link
                                          as="button"
                                          eventKey="New"
                                          onClick={()=>handleTab(1)}
                                        >
                                         New
                                        </Nav.Link>
                    )}
                    {permissions.includes("Property_Approved")&&(
                    <Nav.Link
                      as="button"
                      eventKey="Approved"
                      onClick={()=>handleTab(2)}
                    >
                     Approved
                    </Nav.Link>
                    )}
                                        {permissions.includes("Property_Rejected")&&(
                    <Nav.Link
                      as="button"
                      eventKey="Cancelled"
                      onClick={()=>handleTab(3)}
                    >
                     Rejected
                    </Nav.Link>
                                        )} */}
                  </Nav>
                </nav> 
              </div>
              <div className="card-body pt-2">
                <Tab.Content>
                  <Tab.Pane eventKey="Pending">
                  <PendingPropertyListTable
                      column={pendingColumns}
                      rowsArr={propertiesList}
                   userArr ={userArr}
                  //  userColumn={columns}
                   handleTabExpanded={handleTabExpanded}
                   handleSeeVendor={handleSeeVendor}
                   assignUsers={assignUsers}
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPagePending
                  }
                  setPageSizePending={setPageSizePending}
                  searchValuePagination={searchValuePending}
                  pageSizePagination={pageSizePending}
                  handleSearchPagination={handleSearchPending}
                  totalCountPagination={totalPagePending}
                  handleOnChangePagination={onChangePagePending}
                  totalCount={totalPendingCount}
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onLoadData={onLoadData}
                  setFilterType={setFilterType}
                    />
                  </Tab.Pane>
                  
                  <Tab.Pane eventKey="New">
                  <NewPropertyListTable
                  tab={openTab}
                      column={newColumns}
                      rowsArr={newPropertyList}
                   userArr ={userArr}
                  //  userColumn={columns}
                   handleSeeVendor={handleSeeVendor}
                   handleTabExpanded={handleTabExpanded}
                   handleActionPending={handleActionPending}
                   handleActionMultipleApprove={handleActionMultipleApprove}
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageNew
                  }
                  setPageSizeNew={setPageSizeNew}
                  searchValuePagination={searchValueNew}
                  pageSizePagination={pageSizeNew}
                  handleSearchPagination={handleSearchNew}
                  totalCountPagination={totalPageNew}
                  handleOnChangePagination={onChangePageNew}
                  totalCount={totalNewCount}
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onLoadData={onLoadData}
                  assignUsers={assignUsers}
                  setFilterType={setFilterType}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Approved">
                  <ApprovedPropertyListTable
                      column={columns}
                      rowsArr={approvedPropertyList}
                   userArr ={userArr}
                  //  userColumn={columns}
                   handleSeeVendor={handleSeeVendor}
                   handleTabExpanded={handleTabExpanded}
                   handleActionPending={handleActionPending}
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageApproved
                  }
                  setPageSizeApproved={setPageSizeApproved}
                  searchValuePagination={searchValueApproved}
                  pageSizePagination={pageSizeApproved}
                  handleSearchPagination={handleSearchApproved}
                  totalCountPagination={totalPageApproved}
                  handleOnChangePagination={onChangePageApproved}
                  totalCount={totalApprovedCount}
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onLoadData={onLoadData}
                  setFilterType={setFilterType}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Rejected">
                  <CancelledPropertyListTable
                      column={cancelledColumns}
                      rowsArr={cancelledPropertyList}
                   userArr ={userArr}
                  //  userColumn={columns}
                   handleSeeVendor={handleSeeVendor}
                   handleTabExpanded={handleTabExpanded}
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageCancelled
                  }
                  setPageSizeCancelled={setPageSizeCancelled}
                  searchValuePagination={searchValueCancelled}
                  pageSizePagination={pageSizeCancelled}
                  handleSearchPagination={handleSearchCancelled}
                  totalCountPagination={totalPageCancelled}
                  handleOnChangePagination={onChangePageCancelled}
                  totalCount={totalCancelledCount}
                  handleActionPending={handleActionPending}
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onLoadData={onLoadData}
                  setFilterType={setFilterType}
                    />
                  </Tab.Pane>  
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>
      </div>


      <Modal className="fade" show={permissionModal} centered>
        <Modal.Header>
          <Modal.Title> {modaleType === 0 ? "Please provide reason :-" : "Alert"}</Modal.Title>
          <Button
            onClick={() => setPermissionModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
            {modaleType === 0 ? (
              <>

                <div className="ps-1 align-self-center">
                  <div className="custom-control custom-checkbox d-flex flex-column ">
                  <label
                      className="custom-control-label"
                      style={{ margin: "0px",color:'black' }}
                    >
                   
                    Reason
                    </label>
                    <textarea  className="form-control" style={{minHeight:'112px'}} value={reason}  onChange={(e)=>setReason(e.target.value)}>

                    </textarea>
                    
                    &nbsp; &nbsp;
                   
                  </div>
                </div>
               
              
              </>
            ) : (
              "Are you sure you want to approve this property?"
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setPermissionModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={modaleType == 0 ? handleCancelCalled : handleApproveCalled}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={permissionModalActive} centered>
        <Modal.Header>
          <Modal.Title> Alert</Modal.Title>
          <Button
            onClick={() => setPermissionModalActive(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
           
              Are you sure you want to activate this property ?
       
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setPermissionModalActive(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleActiveProperty}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={approvePropertyModal} centered>
        <Modal.Header>
          <Modal.Title> Approve Property</Modal.Title>
          <Button
            onClick={() => setApprovePropertyModal(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black">
          
              Are you sure you want to approve these property ?
  
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setApprovePropertyModal(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={()=>{handleMultipleApproveCalled()}}
          >
           {isLoading ? "Proceeding": "Proceed"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="lg"
        className="fade bd-example-modal-lg"
        show={auditDisplay}
        centered
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Property History
          </Modal.Title>
          <Button
            onClick={() => setAuditDisplay(false)}
            variant="xl"
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          {/* <table id="example" className="table shadow-hover dataTable display">
            <thead>
              <tr>
                <th>Action Performed</th>
                <th>Performed By</th>
                <th>Timestamp</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ color: "black" }}>
              {actionPerformArray.map((item, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>{item?.ActionPerformed}</td>
                    <td>{item?.ActionPerformedBy}</td>
                    <td>{item?.CreatedOn}</td>
                    <td>
                      {item?.ActionPerformed === "Invoice Updated" &&
                        item?.UpdatedValues !== null && (
                          <i
                            className="material-icons"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleRowExpansion(index)}
                          >
                            {expandedRowIndex === index ? "remove" : "add"}
                          </i>
                        )}
                    </td>
                  </tr>
                  {expandedRowIndex === index && (
                    <tr>
                      <td colSpan="4">
                        <table>
                          <thead>
                            <tr>
                              <th>Key</th>
                              <th>New Value</th>
                              <th>Old Value</th>
                            </tr>
                          </thead>
                          <tbody style={{ color: "black" }}>
                            {parseStringToObjects(item?.UpdatedValues).map(
                              (valueItem, valueIndex) => (
                                <tr key={valueIndex}>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {valueItem?.Key}
                                  </td>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {valueItem?.NewValue}
                                  </td>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {valueItem?.OldValue}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table> */}
             <TableContainer >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Action Performed</TableCell>
            <TableCell>Performed By</TableCell>
            <TableCell>Timestamp</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {actionPerformArray.map((item, index) => (
            <React.Fragment key={index}>
              <TableRow>
                <TableCell>{item?.ActionPerformed}</TableCell>
                <TableCell>{item?.ActionPerformedBy}</TableCell>
                <TableCell>{formatAuditDate(item?.CreatedOn)}</TableCell>
                <TableCell>
                  {item?.ActionPerformed === "Property Updated" &&
                    item?.UpdatedValues !== null && (
                      <IconButton onClick={() => toggleRowExpansion(index)}>
                        {expandedRowIndex === index ? (
                          <KeyboardArrowUp />
                        ) : (
                          <KeyboardArrowDown />
                        )}
                      </IconButton>
                    )}
                </TableCell>
              </TableRow>
              {expandedRowIndex === index && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Collapse in={expandedRowIndex === index} timeout="auto" unmountOnExit>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Key</TableCell>
                            <TableCell>New Value</TableCell>
                            <TableCell>Old Value</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {parseStringToObjects(item?.UpdatedValues).map(
                            (valueItem, valueIndex) => (
                              <TableRow key={valueIndex}>
                                <TableCell>{valueItem?.Key}</TableCell>
                                <TableCell>{valueItem?.NewValue}</TableCell>
                                <TableCell>{valueItem?.OldValue}</TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </Collapse>
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {
        otpModalStatus && <OtpModal 
        otpModal={otpModalStatus} 
        otp={otpValue} 
        handleOtpChange={handleApproveInvoiceOtp} 
        handleModalClose={() => { 
          setOtpValue("")
          setOtpModalStatus(false) }} 
        handleProceed={handleMultipleApproveCalled} 
        resendOtp={handleResendOtp}
        />
      }
    
    </>
  );
};
export default PropertyListPage;
